export default "__VITE_PUBLIC_ASSET__a577cc9a__"